import { Option } from 'types/select';
export const leftBottomTeethOptions: Option[] = [
  { value: '3.1' },
  { value: '3.2' },
  { value: '3.3' },
  { value: '3.4' },
  { value: '3.5' },
  { value: '3.6' },
  { value: '3.7' },
  { value: '3.8' }
].map(({ value }) => ({ label: value, value }));

export const leftTopTeethOptions: Option[] = [
  { value: '2.1' },
  { value: '2.2' },
  { value: '2.3' },
  { value: '2.4' },
  { value: '2.5' },
  { value: '2.6' },
  { value: '2.7' },
  { value: '2.8' }
].map(({ value }) => ({ label: value, value }));
export const rightBottomTeethOptions: Option[] = [
  { value: '4.8' },
  { value: '4.7' },
  { value: '4.6' },
  { value: '4.5' },
  { value: '4.4' },
  { value: '4.3' },
  { value: '4.2' },
  { value: '4.1' }
].map(({ value }) => ({ label: value, value }));

export const rightTopTeethOptions: Option[] = [
  { value: '1.8' },
  { value: '1.7' },
  { value: '1.6' },
  { value: '1.5' },
  { value: '1.4' },
  { value: '1.3' },
  { value: '1.2' },
  { value: '1.1' }
].map(({ value }) => ({ label: value, value }));

export const rightBottomBabyTeethOptions: Option[] = [
  { value: '8.5' },
  { value: '8.4' },
  { value: '8.3' },
  { value: '8.2' },
  { value: '8.1' }
].map(({ value }) => ({ label: value, value }));

export const rightTopBabyTeethOptions: Option[] = [
  { value: '5.5' },
  { value: '5.4' },
  { value: '5.3' },
  { value: '5.2' },
  { value: '5.1' }
].map(({ value }) => ({ label: value, value }));
export const leftBottomBabyTeethOptions: Option[] = [
  { value: '7.5' },
  { value: '7.4' },
  { value: '7.3' },
  { value: '7.2' },
  { value: '7.1' }
].map(({ value }) => ({ label: value, value }));

export const leftTopBabyTeethOptions: Option[] = [
  { value: '6.5' },
  { value: '6.4' },
  { value: '6.3' },
  { value: '6.2' },
  { value: '6.1' }
].map(({ value }) => ({ label: value, value }));
